"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsAnimateWrapper = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var useStyleUpdateAfterToggleTransition_1 = require("../../../../../../../utils/useStyleUpdateAfterToggleTransition");
var OptionsAnimateWrapper = function (_a) {
    var _b;
    var _c;
    var relativeToRef = _a.relativeToRef, showOptions = _a.showOptions, yOrientation = _a.yOrientation, fixPos = _a.fixPos, optionsAnchor = _a.optionsAnchor, children = _a.children, lightboxStyle = _a.lightboxStyle, alignDropdown = _a.alignDropdown, optionsToggleAnimationDuration = _a.optionsToggleAnimationDuration;
    var selectCompRect = (_c = relativeToRef === null || relativeToRef === void 0 ? void 0 : relativeToRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth; // excludes scrollbar
    var optionsDisplay = (0, useStyleUpdateAfterToggleTransition_1.useStyleUpdateAfterToggleTransition)({
        styleOptions: ['hidden', 'block'],
        initStyle: showOptions ? 'block' : 'hidden',
        toggleState: showOptions,
        transitionDuration: optionsToggleAnimationDuration
    }).style;
    var lightboxOffsetFromSelect = 4;
    return (react_1.default.createElement(styled_1.StyledOptionsAnimateWrapper, { showOptions: showOptions, optionsToggleAnimationDuration: optionsToggleAnimationDuration, style: __assign(__assign(__assign({}, (lightboxStyle || {})), { display: optionsDisplay, zIndex: 100000 }), (fixPos
            ? __assign(__assign({ position: "fixed", top: "".concat(fixPos.y - (yOrientation === "top" ? ((selectCompRect === null || selectCompRect === void 0 ? void 0 : selectCompRect.height) + lightboxOffsetFromSelect) || -(lightboxOffsetFromSelect) : -(lightboxOffsetFromSelect)), "px") }, (alignDropdown === "right"
                ? {
                    right: "".concat(viewportWidth - fixPos.right, "px")
                }
                : {
                    left: "".concat(fixPos.x, "px")
                })), (yOrientation === "top" ? { transform: "translateY(-100%)" } : {})) : __assign(__assign({ position: "absolute" }, (optionsAnchor ? (_b = {}, _b[optionsAnchor] = 0, _b) : alignDropdown === "right" ? { right: 0 } : { left: 0 })), (yOrientation === "bottom"
            ? { bottom: -(lightboxOffsetFromSelect), transform: "translateY(100%)" }
            : { top: -(lightboxOffsetFromSelect), transform: "translateY(-100%)" })))) }, children));
};
exports.OptionsAnimateWrapper = OptionsAnimateWrapper;
